import $ from 'jquery';

export default function () {

    function hide_notice_woocommerce() {
        setTimeout(function () {
            $('.woocommerce-message').hide();
            $('.woocommerce-error').hide();

        }, 6000);
    }

    function add_custom_fields_woocommerce() {
        $(document).ready(function () {
            //code to add validation on "Add to Cart" button
            $('.single_add_to_cart_button').click(function () {
                const selected_player_no = $('#selected_player_nr').val();
                const selected_player_label = $('#selected_player_label').val();
                $.ajax({
                    url: cart_ajax.ajaxurl, //AJAX file path - admin_url('admin-ajax.php')
                    type: "POST",
                    data: {
                        //action name
                        action: 'wdm_add_custom_data_options',
                        selected_player_no: selected_player_no,
                        selected_player_label: selected_player_label,
                    },
                    async: false,
                    success: function (data) {
                        //Code, that need to be executed when data arrives after
                        // successful AJAX request execution
                    }
                });
            })
        });
    }

    function select_player() {
        $(document).ready(function () {
            $('.selected-player-id').change(function () {
                const player_id = $('select[name=selected-player-id] option').filter(':selected').val();
                $.ajax({
                    url: cart_ajax.ajaxurl, //AJAX file path - admin_url('admin-ajax.php')
                    type: "POST",
                    dataType: "json",
                    data: {
                        //action name
                        action: 'wdm_get_player_data',
                        player_id: player_id //send request data
                    },
                    async: false,
                    success: function (data) {

                        $('#selected_player_nr').val(data.player_no);
                        $('#selected_player_label').val(data.player_label);
                    }
                });

            })
        });
    }

    function change_player_no() {
        $(document).ready(function () {
            $('#selected_player_nr').change(function () {
                $('.selected-player-id').val(0);

            })
        });
    }

    function change_player_label() {
        $(document).ready(function () {
            $('#selected_player_label').change(function () {
                $('.selected-player-id').val(0);

            })
        });
    }

    hide_notice_woocommerce();
    add_custom_fields_woocommerce();
    select_player();
    change_player_no();
}